import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokensService } from '../services/authorization/tokens.service';

export const authorizationInterceptor: HttpInterceptorFn = (req, next) => {
  const tokensService: TokensService = inject(TokensService);

  const authorizedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${tokensService.accessToken}`
    }
  });

  return next(authorizedRequest);
};
